import React from "react";
import SearchVerifiedTrade from "./SearchVerifiedTrade";
import BlockchainTradingStats from "./BlockchainTradingStats";
import SimplestVerificationTrading from "./SimplestVerificationTrading";

const PublicVerifiedTrade = () => {
  return (
    <div>
      <SearchVerifiedTrade />
      <BlockchainTradingStats />
      <SimplestVerificationTrading />
    </div>
  );
};

export default PublicVerifiedTrade;
